import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ScopeOfPracticeEnum } from '@umss/shared/utils';

@Injectable({
  providedIn: 'root',
})
export class ScopeOfPracticeService {
  private getApiUrl(facilityId: string) {
    return `/api/facilities/${facilityId}/scopes`;
  }

  constructor(private http: HttpClient) {}

  /**
   * Fetch all scopes of practice for a facility.
   * @param facilityId The ID of the facility.
   * @returns An Observable array of ScopeOfPracticeEnum.
   */
  getScopes(facilityId: string): Observable<ScopeOfPracticeEnum[]> {
    return this.http.get<ScopeOfPracticeEnum[]>(this.getApiUrl(facilityId));
  }

  /**
   * Add new scopes of practice to a facility.
   * @param facilityId The ID of the facility.
   * @param scopeIds The IDs of the scopes to add.
   * @returns An Observable that completes when the operation is done.
   */
  addScopes(facilityId: string, scopeIds: string[]): Observable<void> {
    return this.http.post<void>(this.getApiUrl(facilityId), { scopeIds });
  }

  /**
   * Delete a scope of practice from a facility.
   * @param facilityId The ID of the facility.
   * @param scopeId The ID of the scope to delete.
   * @returns An Observable that completes when the operation is done.
   */
  deleteScope(facilityId: string, scopeId: string): Observable<void> {
    return this.http.delete<void>(`${this.getApiUrl(facilityId)}/${scopeId}`);
  }
}
